import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';

import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';

import StickyHeader from '../../../components/StickyHeader';
import { ReportFootprintBreadcrumb } from '../../../components/report/ReportFootprintBreadcrumb';
import StepComponent from '../../../components/steps/StepComponent';

import { Xmark } from '@peacecover/icon';

const categoryItems = [
  {
    title: 'official_content',
    image: '3D.verfied.fill'
  },
  {
    title: 'direct_sighting',
    image: '3D.Eyes'
  },
  {
    title: 'fan_content',
    image: '3D.Sparkling heart'
  },
  {
    title: 'live_broadcast',
    image: '3D.Live'
  }
];

const ReportFootprintsCategoryPage = () => {
  const { updateQueryParams, queryParams } = useQueryParams();
  const navigate = useNavigate();

  const handleCategoryClick = (category: string) => {
    if (category === 'official_content') {
      updateQueryParams({ contentType: category }, '/report-location/footprints/select-activity');
      return;
    }
    updateQueryParams({ contentType: category }, '/report-location/footprints/new');
  };

  return (
    <>
      <StickyHeader
        title={t('ReportFootprintsCompletePage.pageTitle', { defaultValue: '제보하기' }) as string}
        alwaysShowTitle={true}
        showBackButton={false}
        showTitle={true}
        leftContent={
          <Xmark
            size={24}
            className="text-text-main-lv1"
            onClick={() => navigate(`/report-location/footprints?${queryParams.toString()}`)}
          />
        }
      />
      <div className="flex flex-col pt-[calc(54px+env(safe-area-inset-top))] pb-[calc(128px+env(safe-area-inset-bottom))]">
        <div className="px-[24px] py-[10px]">
          <StepComponent currentStep={0} nextStep={1} maxStep={1} title="">
            <div className="flex flex-col gap-[18px]">
              <div className="mx-[-24px]">
                <ReportFootprintBreadcrumb />
              </div>
              <h1 className="text-[26px] font-bold text-text-main-lv1">
                {t('ReportFootprintsCategoryPage.title', {
                  defaultValue: '어떻게 알게 되었나요?'
                })}
              </h1>
            </div>
            <div className="grid grid-cols-2 gap-[12px] mt-[17px]">
              {categoryItems.map((item) => (
                <FootprintCategoryItem
                  key={item.title}
                  item={item}
                  handleCategoryClick={handleCategoryClick}
                />
              ))}
            </div>
          </StepComponent>
        </div>
      </div>
    </>
  );
};

export default ReportFootprintsCategoryPage;

const FootprintCategoryItem = ({
  item,
  handleCategoryClick
}: {
  item: (typeof categoryItems)[number];
  handleCategoryClick: (category: string) => void;
}) => {
  return (
    <button
      type="button"
      onClick={() => handleCategoryClick(item.title)}
      className="flex flex-col rounded-[20px] bg-background-light dark:bg-background-dark border border-separator1 dark:border-separator2 px-[16px] pt-[16px] pb-[20px] gap-[16px] shadow-[0_4px_10px_0_rgba(0,0,0,0.04),0_0_24px_0_rgba(255,255,255,0.30)_inset] dark:shadow-[0_0_12px_0_rgba(0,0,0,0.90),0_0_2px_0_rgba(0,0,0,0.80)] backdrop-blur-[20px] dark:backdrop-blur-0"
    >
      <div className="flex items-center justify-center rounded-full p-[8px] bg-surface-lv1 w-[52px] h-[52px]">
        <img
          src={`/assets/icons/graphic-3d/${item.image}.png`}
          alt={item.title}
          className="w-[36px] h-[36px]"
        />
      </div>
      <div className="flex flex-col text-left gap-[6px] mt-[52px]">
        <p className="text-[15px] font-semibold text-text-main-lv2 leading-[18px]">
          {t(`ReportFootprintsCategoryPage.category.${item.title}`)}
        </p>
        <p className="text-[13px] text-text-main-lv4 whitespace-pre-wrap leading-tight">
          {t(`ReportFootprintsCompletePage.description.${item.title}`)}
        </p>
      </div>
    </button>
  );
};